
import React from 'react';
import { Link } from 'react-router-dom';

const TechnicalSafeguards: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Technical Safeguards: The Foundation of HIPAA Compliance</h2>
      <p className="mb-4 text-gray-700 leading-relaxed">
        Let's explore the technical safeguards your IT infrastructure needs to implement. These are particularly important if you're considering <Link to="/services/network-infrastructure" className="text-itmgmt-bright-blue hover:underline">network infrastructure upgrades</Link> for your healthcare practice.
      </p>

      <h3 className="text-xl font-semibold mb-3 mt-6 text-itmgmt-medium-blue">Network and Communication Security</h3>
      <p className="mb-4 text-gray-700 leading-relaxed">
        Your network infrastructure must protect data as it moves between systems. Our <Link to="/services/cybersecurity" className="text-itmgmt-bright-blue hover:underline">cybersecurity services</Link> can help implement these safeguards.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="border border-gray-200 rounded-lg p-4">
          <h4 className="font-medium mb-2 text-itmgmt-dark-blue">Required Measures</h4>
          <ul className="list-disc ml-5 text-gray-700 text-sm space-y-1">
            <li>Secure, properly configured firewalls</li>
            <li>Encrypted VPN for remote access</li>
            <li>Network segmentation to isolate systems with ePHI</li>
            <li>Intrusion detection/prevention systems</li>
          </ul>
        </div>
        <div className="border border-gray-200 rounded-lg p-4">
          <h4 className="font-medium mb-2 text-itmgmt-dark-blue">Best Practices</h4>
          <ul className="list-disc ml-5 text-gray-700 text-sm space-y-1">
            <li>Regular network vulnerability scanning</li>
            <li>Wireless networks with WPA3 encryption</li>
            <li>Data loss prevention (DLP) solutions</li>
            <li>Network traffic monitoring and analysis</li>
          </ul>
        </div>
      </div>

      <h3 className="text-xl font-semibold mb-3 mt-6 text-itmgmt-medium-blue">Endpoint Security</h3>
      <p className="mb-4 text-gray-700 leading-relaxed">
        Every device that can access ePHI must be properly secured. Consider <Link to="/book" className="text-itmgmt-bright-blue hover:underline">scheduling a consultation</Link> to evaluate your current endpoint security posture.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="border border-gray-200 rounded-lg p-4">
          <h4 className="font-medium mb-2 text-itmgmt-dark-blue">Required Measures</h4>
          <ul className="list-disc ml-5 text-gray-700 text-sm space-y-1">
            <li>Updated antivirus/anti-malware software</li>
            <li>Device encryption (especially mobile devices)</li>
            <li>Secure configuration standards</li>
            <li>Automatic screen locks after inactivity</li>
          </ul>
        </div>
        <div className="border border-gray-200 rounded-lg p-4">
          <h4 className="font-medium mb-2 text-itmgmt-dark-blue">Best Practices</h4>
          <ul className="list-disc ml-5 text-gray-700 text-sm space-y-1">
            <li>Mobile device management (MDM) solutions</li>
            <li>Application whitelisting</li>
            <li>Endpoint detection and response (EDR) tools</li>
            <li>BIOS/UEFI passwords and secure boot</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default TechnicalSafeguards;
